<template>
    <div>
        <a @click.stop="dropdown = !dropdown"
           class="py-0"
           href="#"
           id="navbarDropdown"
           role="button"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false">

            <div class="d-flex align-items-center">
                <AppRadialProgressBar
                    class="d-inline"
                    :key="activeTeamId"
                    :diameter="45"
                    :completed-steps="completedSteps"
                    :total-steps="totalSteps"
                    :strokeWidth="4"
                    stopColor="#8b3694"
                    startColor="#B446BF"
                    innerStrokeColor="#eee">
                    <span class="font-12">
                        <template v-if="progressPercentage < 100">
                            {{ progressPercentage }}%
                        </template>
                        <span v-else>
                            <i class="far fa-check"></i>
                        </span>
                    </span>
                </AppRadialProgressBar>
            </div>
        </a>

        <div v-if="dropdown"
             v-click-outside="closeTasksDropdown"
             class="dropdown-menu dropdown-menu-right d-block"
             aria-labelledby="navbarDropdown">
            <div class="dropdown-header border-bottom font-16 text-semi-bold flex-wrap">
                <template v-if="progressPercentage > 0">
                    <span v-if="progressPercentage < 100">
                        Your {{ progressPercentage }}% of the way to never having to enter an invoice again, not far to go now.
                    </span>
                    <span v-else>
                        Nice work! You're all set to eliminate data entry.
                    </span>
                </template>
                <span>
                    You can watch the
                    <a href="https://youtu.be/PptEQftu0hc?list=PLMYjj8QnffLGuABIsANBwDGSRm_wk1DmX" target="_blank">
                        videos
                    </a>
                    <span v-if="progressPercentage < 100">
                        to learn more about {{ appDisplayName }}.
                    </span>
                    <span v-else>
                        whenever you need a refresher.
                    </span>
                </span>
            </div>

            <div v-for="step in onboardingSteps" :key="step.uuid" class="dropdown-item d-flex flex-row py-3">
                <div>
                    <span class="text-muted">
                        <i v-show="!step.complete" class="fal fa-square"></i>
                    </span>
                    <span class="text-success">
                        <i v-show="step.complete" class="fal fa-square-check"></i>
                    </span>
                </div>
                <div class="pl-2">
                    <div>
                        {{ step.text }}
                    </div>
                </div>
            </div>

            <hr class="m-0">
            <div class="dropdown-footer">
                Subscribe to our
                <a href="https://www.youtube.com/channel/UC9EXVIDcs_lu4nRAh14KW8Q/featured" target="_blank">
                    channel
                </a>
                to get more information.
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import AppRadialProgressBar from '@/components/shared/AppRadialProgressBar'

export default {
    name: 'UserOnboardingProgressBar',
    components: {AppRadialProgressBar},
    data() {
        return {
            dropdown: false
        }
    },
    computed: {
        ...mapGetters([
            'activeTeamId',
            'getOnboarding',
            'onboardingSteps',
            'hasAllOnboardingStepsPassed'
        ]),

        progressPercentage() {
            return (100 - ((this.totalSteps - this.completedSteps) / this.totalSteps) * 100)
        },

        completedSteps() {
            return this.onboardingSteps.filter(step => step.complete).length
        },

        totalSteps() {
            return this.onboardingSteps.length
        }
    },
    methods: {
        openTasksDropdown() {
            this.dropdown = true
        },

        closeTasksDropdown() {
            this.dropdown = false
        }
    },
    mounted() {
        this.$bus.$on('OPEN_PROGRESS_DROPDOWN', this.openTasksDropdown)
    },
    beforeDestroy() {
        this.$bus.$off('OPEN_PROGRESS_DROPDOWN')
    }
}
</script>
<style scoped lang="scss">
.dropdown-menu {
    width: 360px;
    white-space: normal;
    line-height: 30px;

    &:hover {
        cursor: auto;
    }

    .dropdown-header {
        white-space: normal;
        line-height: 30px;
    }

    .dropdown-item {
        color: #000;
    }

    .dropdown-footer {
        font-size: 14px;
        padding: 8px 16px 4px 16px;
    }
}

</style>
